require('bootstrap');
const participantType = "participant";
const assistantType = "assistant";
$(function () {
    const $body = $("body");
    const $applyTypeRow = $(".apply-type-title");
    const typeSelectorClass = ".type-selector";
    const $registrationTypeInput = $("#registration_type");
    let campCounter = 0;

    let formChange = false;
    let currentType = null;
     /* Check count of selected camp  */
    if($(".camp-checkbox:checked").length >= 2){
        campCounter = 2;
        $(".camp-checkbox:not(:checked)").prop("disabled","disabled");
    }

    /* First time select type */
    $body.on('click', typeSelectorClass, function () {
        $(".alert-success").hide();
        $(this).addClass("active");
        const type = $(this).data("type");
        if(type === assistantType){
            $("#main-title-text").html("segítők részére");
        }

        changeTypeSpecificFieldsVisibility(type );
        $registrationTypeInput.val(type);
        $applyTypeRow.addClass("selected");
        $(typeSelectorClass).removeClass("type-selector");
        delayedShow(".forms-container");
    });
    /* Check form change */
    $("#main-form").change(function () {
        formChange = true;
    });
    /* Chnage active apply type */
    $body.on("click", ".btn-yellow-dark", function () {
        if (!$(this).hasClass("active")) {
            currentType = $(this).data("type");

            const $otherElement = currentType  === participantType ?  $('*[data-type="assistant"]') :  $('*[data-type="participant"]');
            if (formChange) {
                $("#modal-type-text").html(currentType === participantType ? "résztvevőre"  : "segítőre" );
                $('#questionModal').modal('show')
            }else{
                $("#main-title-text").html(currentType === participantType ? "" : "segítők részére");
                changeTypeSpecificFieldsVisibility(currentType);
                $registrationTypeInput.val(currentType);
                //changeActiveType($otherELement,$(this))
                $otherElement.removeClass("active");
                $(this).addClass("active");
            }
        }

    });
    /* Form change apprival model confirm */
    $body.on('click',"#hadToChange",function(){
        changeTypeSpecificFieldsVisibility(currentType);
        $registrationTypeInput.val(currentType);
       if(currentType === participantType){
           $('*[data-type="assistant"]').removeClass("active");
           $('*[data-type="participant"]').addClass("active");
       }else{
           $('*[data-type="assistant"]').addClass("active");
           $('*[data-type="participant"]').removeClass("active");
       }
        $("#main-title-text").html(currentType === participantType ? "" : "segítők részére");
        $('#questionModal').modal('hide')
    });
    $body.on('click','#associated_member_yes',function(){
        $("#employerInputs").removeClass("d-none");
        $("#associated_info").removeClass("d-none");
        $("#employer").prop('required',true);
        $("#associated_info_select").prop('required',true);
        $("#associated_familyName").prop('required',true);
        $("#associated_givenName").prop('required',true);
    });

    $body.on('blur', 'input[name="child[birth_date]"],input[name="community[delivery_deadline_time]"]', function () {
        $(this).val($(this).val().replace(/\D/g,'-'));

        var d = new Date($(this).val()),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        if ( year && month && day )
        {
            $(this).val([year, month, day].join('-'));
        }
        else
        {
            $(this).val("");
        }


    })

    $body.on('click','#associated_member_no',function(){
        $("#employerInputs").addClass("d-none");
        $("#associated_info").addClass("d-none");
        $("#employer").prop('required',false);
        $("#associated_info_select").prop('required',false);
        $("#associated_familyName").prop('required',false);
        $("#associated_givenName").prop('required',false);
    });
    $body.on('change','#associated_info_select',function(){
        const selected = $("#associated_info_select option:selected").val()
        if(selected === "parent"){
            $("#associated_familyName").val($("#parent_familyName").val());
            $("#associated_givenName").val($("#parent_givenName").val());
        }
    });

    $body.on('click','#community_service_yes',function(){
        $(".community-service-requirement").removeClass("d-none");

        $(".community-service-requirement input[name='community[education]']").prop('required',true);
        $(".community-service-requirement input[name='community[delivery_deadline_time]']").prop('required',true);
        $(".community-service-requirement input[name='community[certificate_form]']").prop('required',true);
        $(".community-service-requirement input[name='community[agreement_is_required]']").prop('required',true);

    });
    $body.on('click','#community_service_no',function(){
        $(".community-service-requirement").addClass("d-none");

        $(".community-service-requirement input[name='community[education]']").prop('required',false);
        $(".community-service-requirement input[name='community[delivery_deadline_time]']").prop('required',false);
        $(".community-service-requirement input[name='community[certificate_form]']").prop('required',false);
        $(".community-service-requirement input[name='community[agreement_is_required]']").prop('required',false);

    })

    $body.on('click','#payment_szep_kartya',function(){
        $("#szep-kartya-szolgatato").removeClass("d-none");
    });
    $body.on('click','#payment_type_bank_transfer',function(){
        $("#szep-kartya-szolgatato").addClass("d-none");
    })

    /* Camp select */
    $body.on("change",".camp-checkbox",function(){
        const campContainer = $(this).closest(".camp-item-container");
        if($(this).prop("checked")){

            $(campContainer).find(".camp_with_other_person").prop("disabled","");
            campCounter++;
            if(campCounter === 2){
                //$(campContainer).find(".rank-container").removeClass("d-none").addClass("d-flex");

                const $firstCamp = $(campContainer).closest(".camp-container").find(".camp-checkbox:checked");
                $.each($firstCamp,function (){
                    $(this).closest(".camp-item-container").find(".rank-container").removeClass("d-none").addClass("d-flex")
                });


                $(campContainer).find(".rank-container").find("select").val("2");
                // All other checkbox set disabled
                $(".camp-checkbox:not(:checked)").prop("disabled","disabled");
            }
        }else{
            //$(campContainer).find(".rank-container").removeClass("d-flex").addClass("d-none");
            $(campContainer).find(".camp_with_other_person").val("").prop("disabled","disabled");
            if(campCounter === 2){

                $(".camp-checkbox:not(:checked)").prop("disabled","");
                const $firstCamp = $(campContainer).closest(".camp-container").find(".camp-checkbox");
                $.each($firstCamp,function (){
                    $(this).closest(".camp-item-container").find(".rank-container").find("select").val("1");
                    $(this).closest(".camp-item-container").find(".rank-container").removeClass("d-flex").addClass("d-none")
                });
            }
            campCounter--;
        }
    })

    $body.on('change',".rank-selector",function(){
        const baseValue = $(this).val();
        $.each($(".rank-selector"),function(){
            $(this).val(baseValue === "1" ? "2" : "1").prop('selected', true);
        });
        $(this).val(baseValue).prop('selected', true);
    });
});

const changeTypeSpecificFieldsVisibility = (nextType) => {
    if(nextType === participantType){
        $(".participant-content").removeClass("d-none");
        $(".assistant-content").addClass("d-none");
        $(".participant-content input[name='child[height]']").prop('required',true);
        $(".participant-content input[name='child[weight]']").prop('required',true);
        $(".participant-content select[name='camp_visit_info']").prop('required',true);
        $(".participant-content select[name='camp_info_time']").prop('required',true);

        $(".assistant-content input[name='community[service]").prop('required',false);

    }else{
        $(".participant-content").addClass("d-none");
        $(".assistant-content").removeClass("d-none");
        $(".participant-content input[name='child[height]']").prop('required',false);
        $(".participant-content input[name='child[weight]']").prop('required',false);
        $(".participant-content select[name='camp_visit_info']").prop('required',false);
        $(".participant-content select[name='camp_info_time']").prop('required',false);

        $(".assistant-content input[name='community[service]").prop('required',true);
    }
};

const changeActiveType = (nextDataType,current) => {
    current.removeClass("active");
    nextDataType.addClass("active");
};

const delayedShow = (className) => {
    $(className).removeClass("d-none");
    setTimeout(() => {
        $(className).addClass("active");
    }, 100)
};
